var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 41,
    viewBox: "0 0 42 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666992,
    width: 40.6667,
    height: 40.6667,
    rx: 8.33333,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_513_27382",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 8,
    width: 24,
    height: 25
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 8.33337,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_513_27382)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.75 24.3719L25.0385 20.3334L18.75 16.2949V24.3719ZM13.3077 27.8334C12.8026 27.8334 12.375 27.6584 12.025 27.3084C11.675 26.9584 11.5 26.5308 11.5 26.0256V14.6411C11.5 14.136 11.675 13.7084 12.025 13.3584C12.375 13.0084 12.8026 12.8334 13.3077 12.8334H28.6923C29.1974 12.8334 29.625 13.0084 29.975 13.3584C30.325 13.7084 30.5 14.136 30.5 14.6411V26.0256C30.5 26.5308 30.325 26.9584 29.975 27.3084C29.625 27.6584 29.1974 27.8334 28.6923 27.8334H13.3077Z",
    fill: "#F46530"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubr);
export default __webpack_public_path__ + "static/media/youtubr.21e57249b3abd5c0c6b3a6f3af63789a.svg";
export { ForwardRef as ReactComponent };